import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './hooks/use-auth';
import { captureAttribution } from './lib/attribution';
import './index.css';

captureAttribution();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
});

const app = (
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);

const root = document.getElementById('root')!;
// Prerendered pages (/, /grade, 404) already contain the HTML → hydrate it.
// Other routes (and `vite dev`) start empty → render from scratch.
if (root.firstElementChild) hydrateRoot(root, app);
else createRoot(root).render(app);
